.container {
    display: flex;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid var(--blue-lt);
}

.illustration {
    flex: 0 0 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--blue-xlt);
}

.content {
    flex: 0 0 50%;
    display: flex;
    padding: 16px;
    background-color: var(--blue-xlt);
    box-sizing: border-box;
}

.close-button {
    flex-shrink: 0;
    margin-left: 8px;
}

.close-button :global(.svg-close) svg {
    fill: var(--blue-dk);
}

.close-button:hover :global(.svg-close) svg {
    fill: var(--grey-dk);
}
